<mat-sidenav-container class="layout-container">
  <mat-sidenav [opened]="sideMenu().isOpen()" mode="over" (closed)="sideMenu().close()">
    <app-side-menu />
  </mat-sidenav>

  <mat-sidenav-content>
    <div class="layout">
      <header class="layout__header">
        <app-header>
          <button headerLeft mat-icon-button (click)="sideMenu().open()">
            <mat-icon>menu</mat-icon>
          </button>
          @if (user()) {
            <section class="authenticated-user-section" headerRight>
              <button mat-icon-button aria-label="Notifications">
                <mat-icon>notifications_none</mat-icon>
              </button>
              <button mat-icon-button aria-label="Account">
                <mat-icon>sentiment_satisfied</mat-icon>
              </button>
              <bi-button variant="outlined" (clicked)="navigateToCreateListing()"
                >Публикувай</bi-button
              >
            </section>
          } @else {
            <p class="right-action-button" headerRight (click)="navigateToLoginScreen()">
              {{ rightActionButtonLabel() }}
            </p>
          }
        </app-header>
      </header>
      <main class="layout__content">
        <ng-content select="main"></ng-content>
      </main>
      <footer class="layout__footer">
        <ng-content select="footer"></ng-content>
      </footer>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
